import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '../../assets/svg/loader.svg'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "ar-loader",
  src: _imports_0
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "card-item"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "med-card-title" }
const _hoisted_7 = { class: "med-card-info" }
const _hoisted_8 = { class: "med-card-duration" }
const _hoisted_9 = { class: "med-card-available" }
const _hoisted_10 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createElementVNode("figure", null, [
          _createElementVNode("img", {
            src: _ctx.medSession.image,
            alt: "Meditation Cover"
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.medSession.title), 1),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.convertSecondsToTime(_ctx.medSession.duration)) + " min.", 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          (_ctx.isAvailable && !_ctx.allSessionsAvailable)
            ? (_openBlock(), _createElementBlock("i", {
                key: 0,
                class: "svgicon",
                innerHTML: _ctx.icons.check
              }, null, 8, _hoisted_10))
            : _createCommentVNode("", true)
        ])
      ]))
}